import {RouteRecordRaw} from "vue-router";
import GlobalPlayersIndexPage from '../pages/GlobalPlayersIndexPage.vue';
import GlobalTeamsIndexPage from '../pages/GlobalTeamsIndexPage.vue';

export const routes: RouteRecordRaw[] = [
  {
    path: '/global-players',
    name: 'global-players.index',
    component: GlobalPlayersIndexPage,
  },
  {
    path: '/global-teams',
    name: 'global-teams.index',
    component: GlobalTeamsIndexPage,
  }
];
